type OwnProps = {
  name?: string;
};

const defaultProps: Partial<OwnProps> = {
  name: undefined,
};

type Props = OwnProps & typeof defaultProps;

function StatusBadge({ name }: Props) {
  return (
    <div
      className={`status-badge ${name}`}
      data-testid={`status-badge-${name}`}
    />
  );
}

StatusBadge.defaultProps = defaultProps;

export default StatusBadge;
